import { render } from "./HizmetlerMain.vue?vue&type=template&id=1df33cc6&scoped=true"
import script from "./HizmetlerMain.vue?vue&type=script&lang=js"
export * from "./HizmetlerMain.vue?vue&type=script&lang=js"

import "./HizmetlerMain.vue?vue&type=style&index=0&id=1df33cc6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df33cc6"]])

export default __exports__